import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "fixed",
    top: theme.spacing.space24,
    right: theme.spacing.space16,
    zIndex: theme.zIndex.dialog + 1,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    maxWidth: "calc(100vw - 32px)",
    padding: `${theme.spacing.space12}px ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    borderRadius: theme.radius.small,
    background: theme.colors.Background3,
    border: `1px solid ${theme.colors.NotificationSuccess}`,
    color: theme.colors.TextDefault,
  },
  icon: {
    flex: "0 0 auto",
    color: theme.colors.NotificationSuccess,
  },
}));
